import { Form, Input, Modal, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { AddEditFormFieldType, ITenant } from "../redux/types";
import { useAppDispatch, useAppSelector } from "Store/hooks";
import { selectCurrentTenant, selectIsModalOpen } from "../redux/selectors";
import { setIsModalOpen } from "../redux/slice";
import { TenantConstants } from "Constants";
import { selectOrganization } from "Features/Organizations/redux/selectors";
import { IOrganization } from "Features/Organizations/redux/types";

const AddEditTenant = ({ saveEditTenant }: any) => {
  const dispatch = useAppDispatch();
  const currentTenant = useAppSelector(selectCurrentTenant);
  const isModalOpen = useAppSelector(selectIsModalOpen);
  const organizationList = useAppSelector(selectOrganization);
  const [form] = useForm();

  const onFinish = (values: any) => {
    const payload: ITenant = {
      ...values,
      license: values.license,
      updateDtTm: new Date(),
      status: "",
      isActive: true,
      id: currentTenant.id,
    };
    saveEditTenant({
      tenant: payload,
    });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    dispatch(setIsModalOpen(false));
  };
  return (
    <Modal
      title={
        currentTenant.id === -1
          ? TenantConstants.CREATE_TENANT_TEXT
          : TenantConstants.UPDATE_TENANT_TEXT
      }
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={
        currentTenant.id === -1
          ? TenantConstants.CREATE_TENANT_TEXT
          : TenantConstants.UPDATE_TENANT_TEXT
      }
      style={{ top: 20 }}
    >
      <Form
        name="basic"
        initialValues={currentTenant}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        form={form}
      >
        <Form.Item<AddEditFormFieldType>
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the tenant name!" }]}
        >
          <Input disabled={currentTenant.id !== -1} />
        </Form.Item>
        <Form.Item<AddEditFormFieldType>
          label="Organization"
          name="organizationId"
          rules={[{ required: true, message: "Please select Organization!" }]}
        >
          <Select disabled={currentTenant.id !== -1}>
            {organizationList.map((obj: IOrganization) => {
              return (
                <Select.Option key={obj.id} value={obj.id}>
                  {obj.name}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item<AddEditFormFieldType>
          label="Email Address"
          name="createdBy"
          rules={[
            { required: true, message: "Please input Email Address!" },
            { type: "email", message: "Please enter a valid email address" },
          ]}
        >
          <Input disabled={currentTenant.id !== -1} />
        </Form.Item>
        {/* <Form.Item<AddEditFormFieldType>
          label="License Key"
          name={["license", "key"]}
        >
          <Input />
        </Form.Item> */}
        <Form.Item<AddEditFormFieldType>
          label="Deployment Directory"
          name={["deploymentDirectory"]}
        >
          <Input />
        </Form.Item>
        <Form.Item<AddEditFormFieldType>
          label="Staging Directory"
          name={["stagingDirectory"]}
        >
          <Input />
        </Form.Item>
        <Form.Item<AddEditFormFieldType> label="Description" name="description">
          <Input.TextArea rows={4} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditTenant;
